import { render, staticRenderFns } from "./Kraje.vue?vue&type=template&id=20ff9a2c&scoped=true&"
import script from "./Kraje.vue?vue&type=script&lang=js&"
export * from "./Kraje.vue?vue&type=script&lang=js&"
import style0 from "./Kraje.vue?vue&type=style&index=0&id=20ff9a2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ff9a2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/atlassian/pipelines/agent/build/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VSelect})
